import React from "react";
import { AdditionalToolPage } from "../components/additionalcomponents";

export default function AdditionalPages() {
    return <AdditionalToolPage />;
}